const sizes = {
  tablet: 768,
  desktop: 980,
  fullDesktop: 1160,
  maxDesktop: 1440,
}

export default sizes
